/**
 * API Conversations Migrate Plugin
 * Provides migration functionality for conversations between API inboxes
 */

import type { App } from 'vue';
import MigrateConversationsButton from './components/MigrateConversationsButton.vue';
import MigrationStatusBanner from './components/MigrationStatusBanner.vue';

interface InstallContext {
  PluginSystem?: any;
  store?: any;
}

export function install(app: App, { PluginSystem, store }: InstallContext = {}) {
  // Register components globally
  app.component('MigrateConversationsButton', MigrateConversationsButton);
  app.component('MigrationStatusBanner', MigrationStatusBanner);

  console.log('[API-CONVERSATIONS-MIGRATE] ✅ Plugin initialized');
}

export default {
  install,
};
